import { useEffect } from 'react';
import { useNavigate } from 'react-router';

export function useAccountDetailNavGuard(params: {
  isNutriBAD: boolean;
  isSAD: boolean;
  isCSBAD: boolean;
  pathname: string;
}) {
  const { isNutriBAD, isSAD, isCSBAD, pathname } = params;
  const navigate = useNavigate();

  useEffect(() => {
    if (isNutriBAD && !isSAD && !isCSBAD && !pathname.includes('view-only')) {
      navigate('404');
    }
  }, [isNutriBAD, isSAD, isCSBAD, pathname, navigate]);
}
